import { render } from "./prp-graph.vue?vue&type=template&id=6fd6ad2a&scoped=true"
import script from "./prp-graph.vue?vue&type=script&lang=js"
export * from "./prp-graph.vue?vue&type=script&lang=js"

import "./prp-graph.vue?vue&type=style&index=0&id=6fd6ad2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd6ad2a"]])

export default __exports__